import React from 'react';
import './App.css';
import styled from '@emotion/styled';
import CustomizedHook from './components/autocomplete';
import { useEffect, useState } from 'react';
import {
  getDestinations,
  getOrigins,
  getSearchRates,
} from './services/services';
import { Button, Grid } from '@mui/material';
import MobileTable from './components/table';
import DesktopTable from './components/table_desktop';
import _ from 'lodash';
import { buildPdfDownload, formatValues } from './common/pdfmake';
import MuiDialog from './components/dialog';

const ContentWrapper = styled('div')(() => ({
  width: '100%',
}));
const initiaValueOption = { title: 'TODOS' };

const Item = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  marginTop: '0.7rem',
}));

function symbolsColors(value) {
  if (value === 'L') {
    return (
      <span
        style={{
          color: 'white',
          backgroundColor: '#A68ABB',
          padding: '5px 15px',
        }}
      >
        {value}
      </span>
    );
  }
  if (value === 'R') {
    return (
      <span
        style={{
          color: 'white',
          backgroundColor: '#ABB94E',
          padding: '5px 15px',
        }}
      >
        {value}
      </span>
    );
  }
  if (value === 'N') {
    return (
      <span
        style={{
          color: 'white',
          backgroundColor: '#0060A7',
          padding: '5px 15px',
        }}
      >
        {value}
      </span>
    );
  }
  if (value === 'Z') {
    return (
      <span
        style={{
          color: 'white',
          backgroundColor: '#89C4EA',
          padding: '5px 15px',
        }}
      >
        {value}
      </span>
    );
  }
  if (value === 'O') {
    return (
      <span
        style={{
          color: 'white',
          backgroundColor: '#B7AE9A',
          padding: '5px 15px',
        }}
      >
        {value}
      </span>
    );
  }
  if (value === 'E') {
    return (
      <span
        style={{
          color: 'white',
          backgroundColor: '#E9CC1C',
          padding: '5px 15px',
        }}
      >
        {value}
      </span>
    );
  }

  return value;
}

function App() {
  const [origins, setOrigins] = useState([initiaValueOption]);
  const [destinations, setDestinations] = useState([initiaValueOption]);
  const [selectedOrigins, setSelectedOrigins] = useState([initiaValueOption]);
  const [selectedDestinations, setSlectedDestinations] = useState([
    initiaValueOption,
  ]);
  const [tableDataDesktop, setTableDataDesktop] = useState({
    totalRecords: 0,
    rows: [],
  });
  const [tableData, setTableData] = useState({ totalRecords: 0, rows: [] });
  const [columns, setColumns] = useState([]);
  const [columnsDesktop, setColumnsDesktop] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);

  const handleFilter = async () => {
    setLoading(true);
    let responseSearch = await getSearchRates({
      origins: selectedOrigins.reduce(
        (accum, origin) => `${accum},${origin.title}`,
        ''
      ),
      destinations: selectedDestinations.reduce(
        (accum, destination) =>
          `${accum},${destination.title.split('-')[0].trim()}`,
        ''
      ),
    });

    let localColumns = [];

    if (window.innerWidth < 768) {
      localColumns.push({ id: 'origin', label: 'Origen', align: 'left' });
      localColumns.push({ id: 'destination', label: 'Destino', align: 'left' });
      localColumns.push({ id: 'destination_state', label: 'Dpto.' });
      localColumns.push({
        id: 'destination_poblation_type_merch',
        label: 'Tipo Pob. Mcias.',
      });
      if (window?.wp_isMerch) {
        localColumns.push({
          id: 'merch_value_by_kg',
          label: 'Valor',
          format: formatValues,
          align: 'right',
        });
      } else {
        localColumns.push({
          id: 'docs_packages_symbol',
          label: 'Zona',
          align: 'center',
          format: symbolsColors,
        });
      }
      if (responseSearch) {
        setColumns(localColumns);
        setTableData(responseSearch);
      }
    } else {
      if (responseSearch) {
        let originsGroup = _.groupBy(responseSearch.rows, (x) => x.origin);
        let origins = Object.keys(originsGroup);

        origins.forEach((origin) => {
          if (window?.wp_isMerch) {
            localColumns.push({
              id: 'merch_value_by_kg',
              label: origin,
              format: formatValues,
              align: 'right',
            });
          } else {
            localColumns.push({
              id: 'docs_packages_symbol',
              label: origin,
              align: 'center',
              format: symbolsColors,
            });
          }
        });

        let destinationsGroup = _.groupBy(
          responseSearch.rows,
          (x) => `${x.destination}-${x.destination_state}`
        );
        let destinationsKeys = Object.keys(destinationsGroup);
        let destinations = [];
        destinationsKeys.forEach((key) => {
          destinations.push(destinationsGroup[key]);
        });

        setColumnsDesktop(localColumns);
        setTableDataDesktop({
          totalRecords: destinations.length,
          rows: destinations,
        });
      }
    }

    setLoading(false);
  };

  const handleDownload = async () => {
    let foundAll = false;
    selectedOrigins.forEach((item) => {
      if (item.title === 'TODOS') {
        foundAll = true;
      }
    });
    if (selectedOrigins.length > 18 || foundAll) {
      setOpenDialog(true);
      return;
    }

    setPdfLoading(true);
    let responseSearch = await getSearchRates({
      origins: selectedOrigins.reduce(
        (accum, origin) => `${accum},${origin.title}`,
        ''
      ),
      destinations: selectedDestinations.reduce(
        (accum, destination) =>
          `${accum},${destination.title.split('-')[0].trim()}`,
        ''
      ),
    });
    if (responseSearch) {
      let localColumns = [];
      let originsGroup = _.groupBy(responseSearch.rows, (x) => x.origin);
      let origins = Object.keys(originsGroup);

      origins.forEach((origin) => {
        if (window?.wp_isMerch) {
          localColumns.push({
            id: 'merch_value_by_kg',
            label: origin,
            format: formatValues,
            align: 'right',
          });
        } else {
          localColumns.push({
            id: 'docs_packages_symbol',
            label: origin,
            align: 'center',
          });
        }
      });

      let destinationsGroup = _.groupBy(
        responseSearch.rows,
        (x) => `${x.destination}-${x.destination_state}`
      );
      let destinationsKeys = Object.keys(destinationsGroup);
      let destinations = [];
      destinationsKeys.forEach((key) => {
        destinations.push(destinationsGroup[key]);
      });
      let documentTitle = 'DOCUMENTOS Y PAQUETES';

      if (window.wp_isMerch === true) {
        documentTitle = 'MERCANCÍA';
      }

      buildPdfDownload(documentTitle, localColumns, destinations);
    }

    setPdfLoading(false);
  };

  const handleChangeOrigins = (e, value) => {
    let foundAll = false;
    let foundAllIndex = 0;
    value.forEach((item, idx) => {
      if (item.title === 'TODOS') {
        foundAll = true;
        foundAllIndex = idx;
      }
    });

    if (foundAll && foundAllIndex === 0) {
      return setSelectedOrigins(value.filter((item) => item.title !== 'TODOS'));
    }

    if (foundAll && foundAllIndex != 0) {
      return setSelectedOrigins(value.filter((item) => item.title === 'TODOS'));
    }

    if (value.length === 0) {
      return setSelectedOrigins([initiaValueOption]);
    }

    return setSelectedOrigins(value);
  };
  const handleChangeDestinations = (e, value) => {
    let foundAll = false;
    let foundAllIndex = 0;
    value.forEach((item, idx) => {
      if (item.title === 'TODOS') {
        foundAll = true;
        foundAllIndex = idx;
      }
    });

    if (foundAll && foundAllIndex === 0) {
      return setSlectedDestinations(
        value.filter((item) => item.title !== 'TODOS')
      );
    }

    if (foundAll && foundAllIndex != 0) {
      return setSlectedDestinations(
        value.filter((item) => item.title === 'TODOS')
      );
    }

    if (value.length === 0) {
      return setSlectedDestinations([initiaValueOption]);
    }

    return setSlectedDestinations(value);
  };

  const handleResize = () => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
      if (isMobile === false) {
        handleFilter();
      }
    } else {
      setIsMobile(false);
      if (isMobile === true) {
        handleFilter();
      }
    }
  };

  useEffect(() => {
    async function dataFetchOrigins() {
      let originsData = await getOrigins();
      let originsResult =
        originsData?.map((origin) => ({ title: origin.origin })) || [];
      setOrigins([initiaValueOption, ...originsResult]);
    }

    async function dataFechDestinations() {
      let destinationsData = await getDestinations();
      let destinationsResult = destinationsData?.map((destination) => ({
        title: `${destination.destination} ${
          destination.destination_state
            ? `- ${destination.destination_state}`
            : ''
        }`,
      }));
      setDestinations([initiaValueOption, ...destinationsResult]);
    }

    dataFechDestinations();
    dataFetchOrigins();
    if (tableData.totalRecords === 0) {
      handleFilter();
    }

    window.addEventListener('resize', handleResize, false);
  }, []);

  return (
    <ContentWrapper>
      <MuiDialog open={openDialog} handleClose={() => setOpenDialog(false)} />
      <Grid container spacing={2}>
        <Grid item xs={12} md={5}>
          <CustomizedHook
            label={'Origenes'}
            options={origins}
            selectedValues={selectedOrigins}
            defaultValue={[origins[0]]}
            onChange={handleChangeOrigins}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <CustomizedHook
            label={'Destinos'}
            options={destinations}
            selectedValues={selectedDestinations}
            defaultValue={[destinations[0]]}
            onChange={handleChangeDestinations}
          />
        </Grid>
        <Grid item xs={12} md={1}>
          <Item>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => handleFilter()}
            >
              FILTRAR
            </Button>
          </Item>
        </Grid>
        <Grid item xs={12} md={1}>
          <Item>
            <Button
              variant="contained"
              color="primary"
              disabled={pdfLoading}
              onClick={() => handleDownload()}
            >
              {pdfLoading === true ? 'Cargando...' : 'Descargar'}
            </Button>
          </Item>
        </Grid>
        {isMobile === true ? (
          <Grid item xs={12} md={12}>
            <MobileTable
              loading={loading}
              columns={columns}
              rows={tableData.rows}
              totalRow={Number(tableData.totalRecords)}
            />
          </Grid>
        ) : (
          <Grid item xs={12} md={12}>
            <DesktopTable
              loading={loading}
              columns={columnsDesktop}
              rows={tableDataDesktop.rows}
              totalRow={Number(tableDataDesktop.totalRecords)}
            />
          </Grid>
        )}
      </Grid>
    </ContentWrapper>
  );
}

export default App;
